import { render, staticRenderFns } from "./changeXzqh.vue?vue&type=template&id=b1f75610&scoped=true"
import script from "./changeXzqh.vue?vue&type=script&lang=js"
export * from "./changeXzqh.vue?vue&type=script&lang=js"
import style0 from "./changeXzqh.vue?vue&type=style&index=0&id=b1f75610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f75610",
  null
  
)

export default component.exports